const bytesToMB = (bytes: number | string | null) => {
  if (!bytes) return

  const parsedBytes = typeof bytes === 'number' ? bytes : parseInt(bytes, 10)

  if (isNaN(parsedBytes)) {
    throw new Error('Can not get number from income argument')
  }

  const megabytes = parsedBytes / (1024 * 1024)
  return `${Math.floor(megabytes)} MB`
}

export default bytesToMB
